import { Icons } from "../icons/icons";

export const EXPERIENCE_STORAGE_KEY = "experience-mode";

export const DEFAULT_MODE = "aesthetics";

export const VALID_MODES = ["all", "nutrition", "aesthetics"];

export const modeThemeConfig = {
  all: {
    id: "all",
    label: "Todos",
    bodyClass: "mode-all",

    primaryColor: "#C7A05D",
    primaryColorStrong: "#A9823F",
    primaryColorSoft: "rgba(199, 160, 93, 0.15)",

    textColor: "#30271D",
    mutedColor: "#665846",

    overlay: "rgba(196, 165, 140, 0.22)",
    glow: "rgba(196, 165, 140, 0.52)",
    activeGradient: "linear-gradient(135deg, #b89b84, #cfb4a0)",
    activeShadow: "0 10px 20px rgba(184, 155, 132, 0.24)",

    sectionIcon: Icons.HeartHandshake,
    decorativeIcon: Icons.Heart,
    buttonIcon: Icons.Calendar,
    secondaryButtonIcon: Icons.Sparkles,

    whatsappMessageKey: "services",
  },

  nutrition: {
    id: "nutrition",
    label: "Nutrição",
    bodyClass: "mode-nutrition",

    primaryColor: "#7AA06D",
    primaryColorStrong: "#5F8454",
    primaryColorSoft: "rgba(122, 160, 109, 0.16)",

    textColor: "#243325",
    mutedColor: "#506251",

    overlay: "rgba(122, 160, 109, 0.22)",
    glow: "rgba(122, 160, 109, 0.52)",
    activeGradient: "linear-gradient(135deg, #7aa06d, #97bb8b)",
    activeShadow: "0 10px 20px rgba(122, 160, 109, 0.24)",

    sectionIcon: Icons.Leaf,
    decorativeIcon: Icons.Heart,
    buttonIcon: Icons.Calendar,
    secondaryButtonIcon: Icons.Leaf,

    whatsappMessageKey: "nutrition",
  },

  aesthetics: {
    id: "aesthetics",
    label: "Estética",
    bodyClass: "mode-aesthetics",

    primaryColor: "#C4A58C",
    primaryColorStrong: "#A9876C",
    primaryColorSoft: "rgba(196, 165, 140, 0.16)",

    textColor: "#312722",
    mutedColor: "#65544A",

    overlay: "rgba(196, 165, 140, 0.22)",
    glow: "rgba(196, 165, 140, 0.52)",
    activeGradient: "linear-gradient(135deg, #c4a58c, #d8bca6)",
    activeShadow: "0 10px 20px rgba(196, 165, 140, 0.24)",

    sectionIcon: Icons.Sparkles,
    decorativeIcon: Icons.Star,
    buttonIcon: Icons.Calendar,
    secondaryButtonIcon: Icons.Sparkles,

    whatsappMessageKey: "aesthetics",
  },
};

export const experienceModeOptions = VALID_MODES.map((mode) => {
  return modeThemeConfig[mode];
});

export function getModeThemeConfig(mode = DEFAULT_MODE) {
  return modeThemeConfig[mode] || modeThemeConfig[DEFAULT_MODE];
}

export function isValidExperienceMode(mode) {
  return VALID_MODES.includes(mode);
}